import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type CreateLoungeMessageBody = NonNullable<
  paths['/api/v1/posts']['post']['requestBody']
>['content']['application/json'];
export type CreateLoungeMessageResponse =
  paths['/api/v1/posts']['post']['responses'][201]['content']['application/json'];

export type LikeLoungeMessageResponse =
  paths['/api/v1/posts/{id}/like']['post']['responses'][200]['content']['application/json'];

export type GetLatestPostsCountResponse =
  paths['/api/v1/posts/latest_posts_count']['get']['responses'][200]['content']['application/json'];

export async function createLoungeMessage(
  body: CreateLoungeMessageBody
): Promise<CreateLoungeMessageResponse> {
  const { data, error } = await client.POST('/api/v1/posts', {
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when creating lounge message');
  return data;
}

export async function likeLoungeMessage(postId: string): Promise<LikeLoungeMessageResponse> {
  const { data, error } = await client.POST('/api/v1/posts/{id}/like', {
    params: { path: { id: postId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when liking lounge message');
  return data;
}

export async function getLatestPostsCount(
  postId?: string,
  categoryGroup = 'community'
): Promise<GetLatestPostsCountResponse> {
  const query: Record<string, string> = { category_group: categoryGroup };
  if (postId) query.post_id = postId;

  const { data, error } = await client.GET('/api/v1/posts/latest_posts_count', {
    params: {
      query
    },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting latest posts count');
  return data;
}
